import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "task-content" }
const _hoisted_2 = {
  key: 0,
  class: "task-title text-align-left"
}
const _hoisted_3 = { class: "task-description text-align-left" }
const _hoisted_4 = {
  key: 1,
  class: "task-description text-align-left font-bold"
}

import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import { IconName, IconSize } from '@/models/icon-types';

interface Props {
  icon?: IconName;
  iconSize?: IconSize;
  title?: string;
  description: string;
  disabled?: boolean;
  fixedIconSize?: boolean;
  subtitle?: string;
  focused?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TaskCard',
  props: {
    icon: {},
    iconSize: { default: IconSize.HeadlineL },
    title: {},
    description: {},
    disabled: { type: Boolean, default: false },
    fixedIconSize: { type: Boolean, default: true },
    subtitle: {},
    focused: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

function handleClick(event: MouseEvent) {
  if (props.disabled) {
    event.stopPropagation();
    return;
  }
  emit('click');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["task-card", { disabled: _ctx.disabled, focused: _ctx.focused }]),
    onClick: handleClick
  }, [
    (_ctx.icon)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["task-icon-container", { 'fixed-size': _ctx.fixedIconSize }])
        }, [
          _createVNode(AppIcon, {
            name: _ctx.icon,
            size: _ctx.iconSize
          }, null, 8, ["name", "size"])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.title), 1))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.description), 1),
      (_ctx.subtitle)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.subtitle), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.$slots.actions)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "task-action-container",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [
          _renderSlot(_ctx.$slots, "actions")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})